import { render } from "./lrbTable.vue?vue&type=template&id=b9947bba&scoped=true"
import script from "./lrbTable.vue?vue&type=script&lang=js"
export * from "./lrbTable.vue?vue&type=script&lang=js"

import "./lrbTable.vue?vue&type=style&index=0&id=b9947bba&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9947bba"]])

export default __exports__